import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CabinetShell from '../../components/UI/CabinetShell/cabinetShell';
import './employee.css';
import Modal from '../../modal/modal';
import ModalContent from '../../modal/ModalContent';
import ModalStatistic from '../../components/modalContent/statistic/statistic';
import axiosInstance from '../../utils/router/axiosInstance';
import Profile from '../../components/UI/Employee/profile';
import History from '../../components/UI/Employee/history';
import { logger } from '../../utils/logger';

const Employee = () => {
  const [employeeData, setEmployeeData] = useState(null);
  const [isModalActive, setIsModalActive] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [openShifts, setOpenShifts] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get(`website/employee/info/${id}`)
      .then((response) => {
        setData([]);
        setEmployeeData(response.data);
      })
      .catch((error) => {
        logger.error('Error fetching employee data:', error);
      });
  }, [id]);

  useEffect(() => {
    setOpenShifts(0);
    setLoading(true);
    const fetchData = async () => {
      setData([]);
      const currentDate = new Date();
      let count = 0;
      for (let i = 0; i < 5; i++) {
        const date = new Date(currentDate);
        date.setDate(date.getDate() - i);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        try {
          const response = await axiosInstance.get(`website/employee/time/${id}?date=${year},${month},${day},0,0`);
          const responseData = response.data;

          if (Array.isArray(responseData)) {
            // обычный массив смен
            count += responseData.length;
            const entries = responseData.map((entry) => {
              const entryTime = entry.begin === 'None' ? 'Неизвестно' : entry.begin.split(' ')[1].slice(0, 8);
              const exitTime = entry.end === 'None' ? 'Работает' : entry.end.split(' ')[1].slice(0, 8);
              const formattedDate = `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`;
              return {
                date: formattedDate,
                'entry-time': entryTime,
                'exit-time': exitTime,
                begin: entry.begin,
              };
            });

            // сортировка
            entries.sort((a, b) => new Date(b.begin) - new Date(a.begin));
            setData((prevData) => [...prevData, ...entries]);
          } else if (responseData.message === 'Данных по смене нет') {
            // если данных нет — добавим фейковую запись
            const formattedDate = `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`;
            setData((prevData) => [
              ...prevData,
              {
                date: formattedDate,
                'entry-time': '—',
                'exit-time': '—',
                begin: `${formattedDate}`,
                message: 'Данных по смене нет',
              },
            ]);
          } else {
            logger.error('Некорректный формат данных:', responseData);
          }
        } catch (error) {
          logger.error('Ошибка при получении данных:', error);
        }
        setLoading(i < 14 ? true : false);
      }
      setOpenShifts(count);
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  return (
    <CabinetShell title="Сотрудник" floor={false}>
      <div className="content">
        {employeeData && (
          <div className="user-info">
            <Profile
              employeeData={employeeData}
              openShifts={openShifts}
              loading={loading}
              setIsModalActive={setIsModalActive}
              // WEB-7: успешный PATCH обновляет карточку без reload
              onEmployeeUpdate={setEmployeeData}
            />
            <History employeeData={employeeData} user_id={id} />
          </div>
        )}
      </div>
      <Modal active={isModalActive} setActive={setIsModalActive} width={'420px'} height={'600px'}>
        <ModalContent>
          <ModalStatistic data={data} />
        </ModalContent>
      </Modal>
    </CabinetShell>
  );
};

export default Employee;
